import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89b456ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }

import { t } from '@/plugins/i18n'
import { reactive, ref, watch } from 'vue'
import { Delete, Upload, RefreshRight } from '@element-plus/icons-vue'
import { getSign } from '@/apis/oss'
import useFileUtils from '@/util/useFileUtils'
import { uid } from 'uid/dist/index.js'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  limit: {
    type: Number,
    default: 1
  },
  // 文件类型
  limitFile: {
    type: Object,
    default: () => ({
      accept: '.pdf'
    })
  },
  // 回显文件
  file: {
    type: Array,
    default: () => []
  }
},
  emits: ['change', 'getName'],
  setup(__props, { emit }) {

const props = __props

const fileList: any = ref([])
watch(() => props.file, (value) => {
  console.log('watch', value)
  fileList.value = value
}, { immediate: true })

const { getExtension } = useFileUtils()
const host = ref('')
const uploadParams = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: ''
})
const totalFileList: any = ref([]) // 总文件
const delFile = () => {
  fileList.value = []
  handleChange()
}

const beforeUploadValidator: any = {
  '.pdf': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning('文件大小不超过10m')
      return false
    }
    return true
  },
  '.pdf,.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf', 'xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning('文件大小不超过10m')
      return false
    }
    return true
  },
  '.pdf,.doc,.docx,.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf', 'doc', 'docx', 'xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG', 'pdf']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  }
}

const beforeUpload = (file: any) => {
  emit('getName', file.name)
  console.log('beforeUpload', props.limitFile?.accept, file)
  if (beforeUploadValidator[props.limitFile?.accept](file)) {
    return getOssSign(file)
  }
  return false
}

const handleChange = (file: any) => {
  console.log('file', fileList.value)
  emit('change', fileList.value)
}

/**
 * 获取阿里云上传签名等参数
 */
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    getSign()
      .then((res: any) => {
        const data = res.data
        uploadParams.name = file.name
        uploadParams.key = `${data.dir}${uid()}`
        const ext = getExtension(file.name)
        if (ext && ext.length > 0) {
          uploadParams.key = `${uploadParams.key}.${ext}`
        }
        uploadParams.policy = data.policy
        uploadParams.OSSAccessKeyId = data.accessId
        uploadParams.signature = data.signature

        host.value = data.host.replace(/http[s]?:/, location.protocol)
        // this.customDomain = data.customDomain
        // // 上传后文件的访问url
        // file.url = `${this.customDomain}/${this.uploadParams.key}`
        console.log(`${data.customDomain}/${uploadParams.key}`)
        file.url = `${data.customDomain}/${uploadParams.key}`
        resolve(true)
      })
      .catch((error) => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
      })
  })
}
const handleClose = (key: any) => {
  fileList.value.splice(key, 1)
  emit('change', fileList.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_upload, _mergeProps({
      ref: (_value, _refs) => {
        _refs['uploadRef'] = _value
      },
      class: "uploader",
      accept: __props.limitFile?.accept,
      "before-upload": (beforeUpload as any),
      limit: 2,
      action: host.value,
      data: _unref(uploadParams),
      "show-file-list": false,
      "file-list": fileList.value
    }, _ctx.$attrs, { onSuccess: handleChange }), {
      trigger: _withCtx(() => [
        _renderSlot(_ctx.$slots, "trigger", _normalizeProps(_guardReactiveProps({ delFile: delFile })), () => [
          (fileList.value.length==0)
            ? (_openBlock(), _createBlock(_component_el_button, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Upload))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(t)('上传文件')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(fileList.value[0]&&fileList.value[0].name), 1),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RefreshRight))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ])
      ]),
      tip: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tip")
      ]),
      _: 3
    }, 16, ["accept", "before-upload", "action", "data", "file-list"])
  ]))
}
}

})